<template>
  <ValidationObserver v-slot="{ passes }">
    <form @submit.prevent="passes(onSubmit)">
      <div class="container text-left">
        <AsnFieldset />

        <ExchangeFieldset />

        <div v-if="!formData.noExchanges">
          <ExchangeCheckbox
            v-for="item in formData.exchangeOptions"
            :key="item"
            :name="item"
          />
        </div>

        <ContactFieldset />

        <div class="form-row footer">
          <div class="col-xs-12 col-sm-8 col-md-6">
            <div id="frc-wrapper" class="flex justify-center mb-4">
              <div id="friendly-captcha" ref="captcha" v-on:frcEvent="validation"></div>
            </div>
          </div>

          <div class="footer-text col-xs-12 col-sm-4 col-md-6">
            <button
              type="submit"
              class="anx-button"
            >
              Submit >
            </button>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>


<script>
import AsnFieldset from "@/components/AsnFieldset.vue";
import ExchangeFieldset from "@/components/ExchangeFieldset.vue";
import ContactFieldset from "@/components/ContactFieldset.vue";
import ExchangeCheckbox from "@/components/ExchangeCheckbox.vue";
import { initCaptcha } from "./script/captcha";

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import 'whatwg-fetch';

export default {
  name: "Peering",
  components: {
    ExchangeCheckbox,
    AsnFieldset,
    ExchangeFieldset,
    ContactFieldset
  },
  data() {
    return {
      reCaptchaValid: false
    };
  },
  computed: {
    formData() {
      return this.$store.state.formData;
    },
    networkDetails() {
      return this.$store.state.networkDetails;
    }
  },
  created() {
    initCaptcha();
  },
  methods: {
    onSubmit() {
      let error = 0;
      if (this.formData.choosedExchanges.length > 0) {
        for (var i = 0; i < this.formData.choosedExchanges.length; i++) {
          if (this.formData.choosedExchanges[i].ip4.length <= 0) {
            this.formData.choosedExchanges[i].error =
              "The field IPv4 is required!";
            error = 1;
          }
        }

        if (error === 0 && this.reCaptchaValid === true) {
          this.$store.dispatch("fetchData");
          this.$store.commit("resetAll");
          this.$router.push("/success");
        }
      }
    },

    async validation(event) {
      if (event.detail.result !== "ERROR") {
        const token = event.detail.result;
        const res = await fetch("/api/recaptcha/request", {
          method: "POST",
          body: JSON.stringify(token),
          headers: { "Content-Type": "application/json" }
        });

        if (res.status === 200) {
          const success = (await res.json()).success;
          this.reCaptchaValid = success;
        } else {
          this.reCaptchaValid = false;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "/less/anx-button.less";
@import "/less/anx-checkbox.less";
@import "/less/anx-peering-form.less";

.frc-banner {
  width: fit-content;
}
</style>
